import { Component, Input, OnChanges } from '@angular/core';
import { IPedidoNaoLiberadoCardInfoClienteInadimplenteSettings } from './pedido-nao-liberado-card-info-cliente-inadimplente-settings.interface';
import { ITableSettings } from '../../../../../domains/shared/components/table/interfaces/table-settings.interface';
import { ITituloVencido } from '../../../interfaces/titulo-vencido.interface';

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info-cliente-inadimplente',
    templateUrl: './pedido-nao-liberado-card-info-cliente-inadimplente.component.html'
})
export class PedidoNaoLiberadoCardInfoClienteInadimplenteComponent implements OnChanges {
    @Input() settings!: IPedidoNaoLiberadoCardInfoClienteInadimplenteSettings;

    tableSettings: ITableSettings = {
        loading: false,
        isEmpty: true,
        showFooter: false,
        showDisplayCounterRecords: false,
        customContainerClass: 'table-modern table-modern--condensed'
    };

    ngOnChanges(): void {
        const titulos = this.settings?.titulosVencidosNaoLiberado ?? [];
        this.tableSettings = {
            ...this.tableSettings,
            isEmpty: titulos.length === 0
        };
    }

    trackByTituloId(_index: number, titulo: ITituloVencido): number {
        return titulo.id;
    }
}
